import {
    ServerCIEnvironment,
    ServerEnvironment,
    type ServerBaseUrl
} from '~/servers/types';

/**
 * Server configuration for the Sandbox environment (`admin.sandbox.wisesys.info`)
 */
export const sandboxServerConfig: ServerBaseUrl = {
    apiServer: 'https://api.sandbox.wisesys.info',
    auroraApiServer: 'https://sandbox.aurora-v2.wisesys.info',
    equipment: 'https://services-stage.us.wisesys.info',
    socketServer: 'wss://dev.socket.wisesys.info',
    auroraServer: 'https://dev-api.aurora-v2.wisesys.info',
    equipmentSocketServer: 'wss://equipmentsocket-stage.us.wisesys.info',
    environment: ServerEnvironment.SANDBOX,
    CIEnv: ServerCIEnvironment.SANDBOX,
    vehicleProfile:
        'https://y2sdpvqnw0.execute-api.us-east-1.amazonaws.com/development',
    routePathGeometryServer:
        'https://0tc6grz4n9.execute-api.us-east-1.amazonaws.com/development',
    configurableWorkflowServer:
        'https://uu9d8rt95l.execute-api.us-east-1.amazonaws.com/Prod',
    driverCostServer:
        'https://qeyfz3s4nj.execute-api.us-east-1.amazonaws.com/dev',
    bannerService: 'https://tp3ei4l6wg.execute-api.us-east-1.amazonaws.com/dev'
};
